import {  MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { environment } from "../environments/environment";


export const msalInstance = new PublicClientApplication({ // MSAL Configuration
    auth: {
        clientId: environment.msalConfig.auth.clientId,
        authority: environment.msalConfig.auth.authority,
        redirectUri: environment.msalConfig.auth.redirectUri,
        postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true, // set to true for IE 11
    },
    system: {
        loggerOptions: {
            loggerCallback: (logLevel, message, piiEnabled) => {
                console.log('MSAL Logging: ', message);
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Error
        }
    }
})

export const msalGuardConfig: MsalGuardConfiguration = {
    interactionType: InteractionType.Redirect, // MSAL Guard Configuration
    authRequest: {
        scopes: ['user.read']
    },
};

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {

    const protectedResourceMap = new Map<string, Array<string>>();

    protectedResourceMap.set(environment.msalProtectedApis.graphApi.endpoint, environment.msalProtectedApis.graphApi.scopes); // MS Graph API for user profile access
    protectedResourceMap.set(environment.msalProtectedApis.openAi.endpoint, environment.msalProtectedApis.openAi.scopes); // OpenAI API
    protectedResourceMap.set(environment.msalProtectedApis.webSocket.endpoint, environment.msalProtectedApis.webSocket.scopes); // Web Socket API


    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
};
